import { createApp } from 'vue';
import App from './App.vue';
import router from './routers';
import pinia from './stores';

const app = createApp(App);

// 定义指令对element plus按钮失焦处理
// app.directive('blur', {
//     created(el, binding, vnode) {
//         if (vnode?.type === 'button') {
//             el.addEventListener('click', () => el?.blur());
//         }
//     },
//     unmounted(el) {
//         el.removeEventListener('click', () => el?.blur());
//     },
// });

app.use(router).use(pinia).mount('#app');
